// // import React, { useState } from "react";
// // import "./Submit_Your_Review.css";
// // import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// // import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
// // import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
// // import Rating from "react-rating";
// // import { Form } from "react-bootstrap";
// // import Green_btn from "../../../common-components/common_btn/green_btn/Green_btn";
// // import Success_Modal from "../../../common-components/common_modal/success_modal/Success_Modal";
// // import { useForm, Controller } from "react-hook-form";
// // import { useDispatch, useSelector } from "react-redux";
// // import { postRating } from "../../../../features/rating/ratingSlice";
// // import Set_New_Password_Modal from "../../../common-components/common_modal/set_new_password_modal/Set_New_Password_Modal";
// // import Reset_Password_Modal from "../../../common-components/common_modal/reset_password_modal/Reset_Password_Modal";
// // import Login_Modal from "../../../common-components/common_modal/login_modal/Login_Modal";
// // import { allReviewRating, AvgReviewRating } from "../../../../features/review_rating/review_ratingSlice";

// // function Submit_Your_Review({ product }) {
// //   const [modalShow, setModalShow] = React.useState(false);
// //   const [images, setImages] = useState([]);

// //   const handleImageChange = (e) => {
// //     const files = Array.from(e.target.files);
// //     setImages(files);
// //   };
// //   const {
// //     register,
// //     handleSubmit,
// //     control,
// //     formState: { errors },
// //     reset,
// //   } = useForm({
// //     defaultValues: {
// //       name: "",
// //       email: "",
// //       review: "",
// //       rating: "",
// //     },
// //   });
// //   const dispatch = useDispatch();
// //   const onSubmit = async (d) => {
// //     const formData = new FormData();

// //     formData.append("ratings", d.ratings);
// //     formData.append("review", d.review);
// //     formData.append("product_id", product?.id);

// //     images.forEach((img, index) => {
// //       formData.append(`image${index}`, img);
// //     });

// //     formData.append("imageCount", images.length);

// //     const res = await dispatch(postRating(formData));

// //     if (res.meta?.requestStatus === "fulfilled") {
// //       setModalShow(true);
// //       reset();
// //       setImages([]);

// //       dispatch(
// //         AvgReviewRating({
// //           product_id: product.id,
// //         })
// //       );

// //       dispatch(
// //         allReviewRating({
// //           product_id: product.id,
// //         })
// //       );
// //     }
// //   };

// //   const isSignin = useSelector((state) => state.auth.is_signin);
// //   const [email, setEmail] = useState();
// //   const [contact, setContact] = useState();
// //   const [showResetModal, setShowResetModal] = useState(false);
// //   const [showSetPassModal, setShowSetPassModal] = useState(false);
// //   const [showSuccessModal, setShowSucsessModal] = useState(false);
// //   const [showAccountCreted, setShowAccountCreted] = useState(false);
// //   const [showLoginModal, setShowLoginModal] = useState(false);
// //   return (
// //     <>
// //       <section className="Submit_Your_Review">
// //         <div className="heading_holder">
// //           <h4>Submit Your Review</h4>
// //           <p>Add Your Rating</p>

// //           <Controller
// //             name="ratings"
// //             control={control}
// //             rules={{ required: "Rating is required" }}
// //             render={({ field }) => (
// //               <div>
// //                 <Rating
// //                   {...field}
// //                   initialRating={field.value}
// //                   onChange={field.onChange}
// //                   emptySymbol={<FontAwesomeIcon icon={farStar} color="#ccc" />}
// //                   fullSymbol={
// //                     <FontAwesomeIcon icon={fasStar} color="#FFD700" />
// //                   }
// //                   fractions={2}
// //                 />
// //                 {errors.ratings && (
// //                   <p className="text-danger mt-1">{errors.ratings.message}</p>
// //                 )}
// //               </div>
// //             )}
// //           />
// //         </div>

// //         <div className="form_holder">
// //           <Form>
// //             <div className="row">
// //               {/* <div className="col-md-6">
// //                 <Form.Group className="input_group">
// //                   <Form.Control
// //                     type="text"
// //                     placeholder="Add Name"
// //                     {...register("name", { required: "Name is required" })}
// //                   />
// //                   {errors.name && (
// //                     <p className="text-danger mt-1">{errors.name.message}</p>
// //                   )}
// //                 </Form.Group>
// //               </div>

// //               <div className="col-md-6">
// //                 <Form.Group className="input_group">
// //                   <Form.Control
// //                     type="text"
// //                     placeholder="Email Address"
// //                     {...register("email", {
// //                       required: "Email is required",
// //                       pattern: {
// //                         value: /^\S+@\S+$/i,
// //                         message: "Invalid email format",
// //                       },
// //                     })}
// //                   />
// //                   {errors.email && (
// //                     <p className="text-danger mt-1">{errors.email.message}</p>
// //                   )}
// //                 </Form.Group>
// //               </div> */}

// //               <div className="col-md-12">
// //                 <Form.Group className="input_group">
// //                   <input
// //                     type="file"
// //                     multiple
// //                     accept="image/*"
// //                     onChange={handleImageChange}
// //                   />

// //                 </Form.Group>
// //               </div>

// //               <div className="col-md-12">
// //                 <Form.Group className="input_group">
// //                   <Form.Control
// //                     as="textarea"
// //                     rows={3}
// //                     placeholder="Write review..."
// //                     {...register("review", {
// //                       required: "Review is required",
// //                     })}
// //                   />
// //                   {errors.review && (
// //                     <p className="text-danger mt-1">{errors.review.message}</p>
// //                   )}
// //                 </Form.Group>
// //               </div>
// //               {isSignin && (
// //                 <div className="col-md-12">
// //                   <div className="btn_holder">
// //                     <Green_btn
// //                       btnText={"Submit Review"}
// //                       onClick={handleSubmit(onSubmit)}
// //                     />
// //                   </div>
// //                 </div>
// //               )}
// //               {!isSignin && (
// //                 <div className="col-md-12">
// //                   <div className="btn_holder">
// //                     <Green_btn
// //                       btnText={"Submit Review"}
// //                       onClick={() => {
// //                         setShowLoginModal(true);
// //                       }}
// //                     />
// //                   </div>
// //                 </div>
// //               )}
// //             </div>
// //           </Form>
// //         </div>
// //       </section>

// //       <Login_Modal
// //         show={showLoginModal}
// //         onHide={() => {
// //           setShowLoginModal(false);
// //         }}
// //         setShowResetModal={() => setShowResetModal(true)}
// //         setShowAccountCreted={() => setShowAccountCreted(true)}
// //       />

// //       <Reset_Password_Modal
// //         email={email}
// //         setEmail={setEmail}
// //         contact={contact}
// //         setContact={setContact}
// //         show={showResetModal}
// //         onHide={() => {
// //           setShowResetModal(false);
// //         }}
// //         setShowSetPassModal={() => setShowSetPassModal(true)}
// //       />

// //       <Set_New_Password_Modal
// //         email={email}
// //         setEmail={setEmail}
// //         contact={contact}
// //         setContact={setContact}
// //         show={showSetPassModal}
// //         onHide={() => {
// //           setShowSetPassModal(false);
// //         }}
// //         setShowSucsessModal={() => setShowSucsessModal(true)}
// //       />

// //       <Success_Modal
// //         show={showSuccessModal}
// //         onHide={() => {
// //           setShowSucsessModal(false);
// //         }}
// //         successText="Password Reseted Successfully!"
// //       />

// //       <Success_Modal
// //         show={showAccountCreted}
// //         onHide={() => {
// //           setShowAccountCreted(false);
// //         }}
// //         successText="Account Created Successful!"
// //       />

// //       <Success_Modal
// //         show={modalShow}
// //         onHide={() => setModalShow(false)}
// //         successText="Submitted Successfully!"
// //       />
// //     </>
// //   );
// // }

// // export default Submit_Your_Review;

// import React, { useState } from "react";
// import "./Submit_Your_Review.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
// import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
// import Rating from "react-rating";
// import { Form, Modal } from "react-bootstrap";
// import Green_btn from "../../../common-components/common_btn/green_btn/Green_btn";
// import Success_Modal from "../../../common-components/common_modal/success_modal/Success_Modal";
// import { useForm, Controller } from "react-hook-form";
// import { useDispatch, useSelector } from "react-redux";
// import { postRating } from "../../../../features/rating/ratingSlice";
// import Set_New_Password_Modal from "../../../common-components/common_modal/set_new_password_modal/Set_New_Password_Modal";
// import Reset_Password_Modal from "../../../common-components/common_modal/reset_password_modal/Reset_Password_Modal";
// import Login_Modal from "../../../common-components/common_modal/login_modal/Login_Modal";
// import {
//   allReviewRating,
//   AvgReviewRating,
// } from "../../../../features/review_rating/review_ratingSlice";

// function Submit_Your_Review({ product, show, onHide }) {
//   const [modalShow, setModalShow] = useState(false);
//   const [images, setImages] = useState([]);

//   const handleImageChange = (e) => {
//     const files = Array.from(e.target.files);
//     setImages(files);
//   };

//   const {
//     register,
//     handleSubmit,
//     control,
//     formState: { errors },
//     reset,
//   } = useForm({
//     defaultValues: {
//       review: "",
//       ratings: "",
//     },
//   });

//   const dispatch = useDispatch();

//   const onSubmit = async (d) => {
//     const formData = new FormData();

//     formData.append("ratings", d.ratings);
//     formData.append("review", d.review);
//     formData.append("product_id", product?.id);

//     images.forEach((img, index) => {
//       formData.append(`image${index}`, img);
//     });

//     formData.append("imageCount", images.length);

//     const res = await dispatch(postRating(formData));

//     if (res.meta?.requestStatus === "fulfilled") {
//       setModalShow(true);

//       reset();
//       setImages([]);

//       dispatch(
//         AvgReviewRating({
//           product_id: product.id,
//         }),
//       );

//       dispatch(
//         allReviewRating({
//           product_id: product.id,
//         }),
//       );

//       onHide();
//     }
//   };

//   const isSignin = useSelector((state) => state.auth.is_signin);

//   const [email, setEmail] = useState();
//   const [contact, setContact] = useState();
//   const [showResetModal, setShowResetModal] = useState(false);
//   const [showSetPassModal, setShowSetPassModal] = useState(false);
//   const [showSuccessModal, setShowSucsessModal] = useState(false);
//   const [showAccountCreted, setShowAccountCreted] = useState(false);
//   const [showLoginModal, setShowLoginModal] = useState(false);

//   return (
//     <>
//       <Modal
//         show={show}
//         onHide={onHide}
//         centered
//         className="Submit_Review_Modal"
//       >
//         <Modal.Body>
//           <section className="Submit_Your_Review">
//             <div className="heading_holder">
//               <h4>Write a review</h4>
//             </div>

//             <div className="form_holder">
//               <Form>
//                 <div className="row">
//                   <div className="col-md-12">
//                     <Form.Group className="input_group">
//                       <Form.Control
//                         as="textarea"
//                         rows={3}
//                         placeholder="Write your review hera"
//                         {...register("review", {
//                           required: "Review is required",
//                         })}
//                       />

//                       {errors.review && (
//                         <p className="text-danger mt-1">
//                           {errors.review.message}
//                         </p>
//                       )}
//                     </Form.Group>
//                   </div>

//                   {/* <div className="col-md-12 review_action_wrapper">
//                     <Controller
//                       name="ratings"
//                       control={control}
//                       rules={{ required: "Rating is required" }}
//                       render={({ field }) => (
//                         <div className="rating_star_holder">
//                           <Rating
//                             {...field}
//                             initialRating={field.value}
//                             onChange={field.onChange}
//                             emptySymbol={
//                               <FontAwesomeIcon icon={farStar} color="#d9d9d9" />
//                             }
//                             fullSymbol={
//                               <FontAwesomeIcon icon={fasStar} color="#f4b400" />
//                             }
//                             fractions={2}
//                           />

//                           {errors.ratings && (
//                             <p className="text-danger mt-1">
//                               {errors.ratings.message}
//                             </p>
//                           )}
//                         </div>
//                       )}
//                     />
//                     {isSignin && (
//                       <div className="col-md-12">
//                         <div className="btn_holder">
//                           <Green_btn
//                             btnText={"Post Now"}
//                             onClick={handleSubmit(onSubmit)}
//                           />
//                         </div>
//                       </div>
//                     )}

//                     {!isSignin && (
//                       <div className="col-md-12">
//                         <div className="btn_holder">
//                           <Green_btn
//                             btnText={"Post Now"}
//                             onClick={() => setShowLoginModal(true)}
//                           />
//                         </div>
//                       </div>
//                     )}
//                   </div> */}
//                   <div className="review_action_wrapper">
//                     <Controller
//                       name="ratings"
//                       control={control}
//                       rules={{ required: "Rating is required" }}
//                       render={({ field }) => (
//                         <div className="rating_star_holder">
//                           <Rating
//                             {...field}
//                             initialRating={field.value}
//                             onChange={field.onChange}
//                             emptySymbol={
//                               <FontAwesomeIcon icon={farStar} color="#d9d9d9" />
//                             }
//                             fullSymbol={
//                               <FontAwesomeIcon icon={fasStar} color="#f4b400" />
//                             }
//                             fractions={2}
//                           />

//                           {errors.ratings && (
//                             <p className="text-danger mt-1">
//                               {errors.ratings.message}
//                             </p>
//                           )}
//                         </div>
//                       )}
//                     />

//                     {isSignin ? (
//                       <div className="btn_holder">
//                         <Green_btn
//                           btnText={"Post Now"}
//                           onClick={handleSubmit(onSubmit)}
//                         />
//                       </div>
//                     ) : (
//                       <div className="btn_holder">
//                         <Green_btn
//                           btnText={"Post Now"}
//                           onClick={() => setShowLoginModal(true)}
//                         />
//                       </div>
//                     )}
//                   </div>

//                   {/* <div className="col-md-12">
//                     <Form.Group className="input_group mt-3">
//                       <input
//                         type="file"
//                         multiple
//                         accept="image/*"
//                         onChange={handleImageChange}
//                         className="form-control"
//                       />
//                     </Form.Group>
//                   </div> */}
//                 </div>
//               </Form>
//             </div>
//           </section>
//         </Modal.Body>
//       </Modal>

//       <Login_Modal
//         show={showLoginModal}
//         onHide={() => {
//           setShowLoginModal(false);
//         }}
//         setShowResetModal={() => setShowResetModal(true)}
//         setShowAccountCreted={() => setShowAccountCreted(true)}
//       />

//       <Reset_Password_Modal
//         email={email}
//         setEmail={setEmail}
//         contact={contact}
//         setContact={setContact}
//         show={showResetModal}
//         onHide={() => {
//           setShowResetModal(false);
//         }}
//         setShowSetPassModal={() => setShowSetPassModal(true)}
//       />

//       <Set_New_Password_Modal
//         email={email}
//         setEmail={setEmail}
//         contact={contact}
//         setContact={setContact}
//         show={showSetPassModal}
//         onHide={() => {
//           setShowSetPassModal(false);
//         }}
//         setShowSucsessModal={() => setShowSucsessModal(true)}
//       />

//       <Success_Modal
//         show={showSuccessModal}
//         onHide={() => {
//           setShowSucsessModal(false);
//         }}
//         successText="Password Reseted Successfully!"
//       />

//       <Success_Modal
//         show={showAccountCreted}
//         onHide={() => {
//           setShowAccountCreted(false);
//         }}
//         successText="Account Created Successful!"
//       />

//       <Success_Modal
//         show={modalShow}
//         onHide={() => setModalShow(false)}
//         successText="Submitted Successfully!"
//       />
//     </>
//   );
// }

// export default Submit_Your_Review;

import React, { useEffect, useState } from "react";
import "./Submit_Your_Review.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
import Rating from "react-rating";
import { Form, Modal } from "react-bootstrap";
import Green_btn from "../../../common-components/common_btn/green_btn/Green_btn";
import Success_Modal from "../../../common-components/common_modal/success_modal/Success_Modal";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { postRating } from "../../../../features/rating/ratingSlice";
import Set_New_Password_Modal from "../../../common-components/common_modal/set_new_password_modal/Set_New_Password_Modal";
import Reset_Password_Modal from "../../../common-components/common_modal/reset_password_modal/Reset_Password_Modal";
import Login_Modal from "../../../common-components/common_modal/login_modal/Login_Modal";
import {
  allReviewRating,
  AvgReviewRating,
} from "../../../../features/review_rating/review_ratingSlice";
import Delete_Modal from "../../../common-components/common_modal/delete_modal/Delete_Modal";

function Submit_Your_Review({ product, show, onHide }) {
  const [modalShow, setModalShow] = useState(false);
  const [images, setImages] = useState([]);
  const [text, setText] = useState("Review Submitted!");

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    setImages((prevImages) => [...prevImages, ...files]);

    // Allows selecting the same image again
    e.target.value = "";
  };

  const handleDeleteImage = (index) => {
    setImages((prevImages) =>
      prevImages.filter((_, imageIndex) => imageIndex !== index),
    );
  };

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      review: "",
      ratings: "",
    },
  });

  const dispatch = useDispatch();

  const onSubmit = async (d) => {
    const formData = new FormData();

    formData.append("ratings", d.ratings);
    formData.append("review", d.review);
    formData.append("product_id", product?.id);

    images.forEach((img, index) => {
      formData.append(`image${index}`, img);
    });

    formData.append("imageCount", images.length);

    const res = await dispatch(postRating(formData));

    // if (res.meta?.requestStatus === "fulfilled") {
    //   setModalShow(true);

    //   reset();
    //   setImages([]);

    //   dispatch(
    //     AvgReviewRating({
    //       product_id: product.id,
    //     }),
    //   );

    //   dispatch(
    //     allReviewRating({
    //       product_id: product.id,
    //     }),
    //   );

    //   onHide();
    // }

    if (res.meta?.requestStatus === "fulfilled") {
      setShowSucsessModal(true);
      await dispatch(
        AvgReviewRating({
          product_id: product.id,
        }),
      );
      await dispatch(
        allReviewRating({
          product_id: product.id,
        }),
      );
      setTimeout(() => {
        setShowSucsessModal(false);
        onHide();
      }, 2000);
      reset();
    } else if (res.meta?.requestStatus === "rejected") {
      setShowErrorModal(true);
      setText(res?.payload?.errors || "Something Went Wrong!");
      setTimeout(() => {
        setShowErrorModal(false);
        // setText("Review Submitted!");
      }, 2000);
    }
  };

  const isSignin = useSelector((state) => state.auth.is_signin);

  const [email, setEmail] = useState();
  const [contact, setContact] = useState();
  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [showAccountCreted, setShowAccountCreted] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  useEffect(() => {
    if (!show) {
      reset();
      setImages([]);
    }
  }, [show]);

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        centered
        className="Submit_Review_Modal"
      >
        <button
          type="button"
          className="review_modal_close_btn"
          onClick={onHide}
          aria-label="Close"
        >
          {" "}
          ×{" "}
        </button>
        <Modal.Body>
          <section className="Submit_Your_Review">
            <div className="heading_holder">
              <h4>Write a review</h4>
            </div>

            <div className="form_holder">
              <Form>
                <div className="row">
                  {/* LEFT SIDE - ORIGINAL REVIEW SECTION */}
                  <div className="col-md-12">
                    <Form.Group className="input_group">
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Write your review here"
                        {...register("review", {
                          required: "Review is required",
                        })}
                      />

                      {errors.review && (
                        <p className="text-danger mt-1">
                          {errors.review.message}
                        </p>
                      )}
                    </Form.Group>
                  </div>

                  {/* RIGHT SIDE - IMAGE UPLOAD */}
                  <div className="col-md-12">
                    <Form.Group className="review_image_upload_group">
                      <div className="review_image_upload_box">
                        <input
                          type="file"
                          id="reviewImages"
                          multiple
                          accept="image/*"
                          onChange={handleImageChange}
                          className="review_image_input"
                        />

                        <label
                          htmlFor="reviewImages"
                          className="review_image_upload_label"
                        >
                          <div className="upload_icon">+</div>

                          <h6>Upload Images</h6>

                          <p>Click to upload multiple images</p>
                        </label>
                      </div>

                      {images.length > 0 && (
                        <div className="review_image_preview">
                          {images.map((image, index) => (
                            <div
                              className="review_preview_item"
                              key={`${image.name}-${index}`}
                            >
                              <img
                                src={URL.createObjectURL(image)}
                                alt={`Review ${index + 1}`}
                              />

                              <button
                                type="button"
                                className="review_image_delete"
                                onClick={() => handleDeleteImage(index)}
                                aria-label={`Delete image ${index + 1}`}
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </Form.Group>
                  </div>
                  <div className="review_action_wrapper mt-2">
                    <Controller
                      name="ratings"
                      control={control}
                      defaultValue={0}
                      rules={{
                        validate: (value) => {
                          const rating = Number(value);

                          if (!rating || rating <= 0) {
                            return "Rating is required";
                          }

                          if (rating > 5) {
                            return "Rating must be between 1 and 5";
                          }

                          return true;
                        },
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <div className="rating_star_holder">
                          <Rating
                            initialRating={field.value || 0}
                            onChange={(value) => {
                              field.onChange(value);
                            }}
                            emptySymbol={
                              <FontAwesomeIcon icon={farStar} color="#d9d9d9" />
                            }
                            fullSymbol={
                              <FontAwesomeIcon icon={fasStar} color="#f4b400" />
                            }
                            fractions={2}
                          />

                          {error && (
                            <p className="text-danger mt-1">{error.message}</p>
                          )}
                        </div>
                      )}
                    />

                    {isSignin ? (
                      <div className="btn_holder">
                        <Green_btn
                          btnText={"Post Now"}
                          onClick={handleSubmit(onSubmit)}
                        />
                      </div>
                    ) : (
                      <div className="btn_holder">
                        <Green_btn
                          btnText={"Post Now"}
                          onClick={() => setShowLoginModal(true)}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Form>
            </div>
          </section>
        </Modal.Body>
      </Modal>

      <Login_Modal
        show={showLoginModal}
        onHide={() => {
          setShowLoginModal(false);
        }}
        setShowResetModal={() => setShowResetModal(true)}
        setShowAccountCreted={() => setShowAccountCreted(true)}
      />

      <Reset_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showResetModal}
        onHide={() => {
          setShowResetModal(false);
        }}
        setShowSetPassModal={() => setShowSetPassModal(true)}
      />

      <Set_New_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showSetPassModal}
        onHide={() => {
          setShowSetPassModal(false);
        }}
        setShowSucsessModal={() => setShowSucsessModal(true)}
      />

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="Password Reseted Successfully!"
      />

      <Success_Modal
        show={showAccountCreted}
        onHide={() => {
          setShowAccountCreted(false);
        }}
        successText="Account Created Successful!"
      />

      <Success_Modal
        show={showSuccessModal}
        onHide={() => setShowSucsessModal(false)}
        successText={text}
      />
      <Delete_Modal
        show={showErrorModal}
        onHide={() => setShowErrorModal(false)}
        successText={text}
      />
    </>
  );
}

export default Submit_Your_Review;
